import * as React from 'react';
export const IcWhatsapp = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.44 13.62c-.22-.11-1.35-.66-1.56-.74-.21-.08-.36-.11-.51.12-.15.23-.59.74-.73.89-.14.15-.26.17-.49 0a6.113 6.113 0 01-1.84-1.12A6.841 6.841 0 0110 11.25c-.14-.23 0-.35.1-.47s.23-.26.34-.39c.093-.116.17-.244.23-.38a.4.4 0 000-.4c-.06-.11-.51-1.23-.71-1.68-.2-.45-.38-.38-.51-.38L9 7.53a.87.87 0 00-.61.28 2.55 2.55 0 00-.8 1.9 4.33 4.33 0 00.94 2.34 9.33 9.33 0 003.9 3.43c2.33.91 2.33.6 2.75.56A2.26 2.26 0 0016.75 15a1.85 1.85 0 00.13-1.08c-.05-.13-.21-.18-.44-.3zM12.17 2.5a9.28 9.28 0 00-9.32 9.26 9.12 9.12 0 001.33 4.77l-1.68 5 5.16-1.64A9.41 9.41 0 0012.17 21a9.259 9.259 0 100-18.51v.01zm0 17a7.86 7.86 0 01-4.31-1.29l-3 1 1-2.89a7.71 7.71 0 01-1.5-4.56 7.84 7.84 0 117.84 7.78l-.03-.04z'
      fill='currentColor'
    />
  </svg>
);
